import React from 'react'

const WhatsappReminder = ({selectedClients}) => {
  console.log(selectedClients,'selectedClientsW')
  return (
    <div>whatsappRemidxfrcgthgnder</div>
  )
}

export default WhatsappReminder